// extracted by mini-css-extract-plugin
export default {"button":"expander_button__iC0D3"};